import { useDispatch } from "react-redux";

import type { IButtonProps } from "@similarweb/ui-components";

import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";

import SignalsManagementButton from "../../components/buttons/SignalsManagementButton/SignalsManagementButton";
import { usePermanentSignalsAmountBySource } from "../../hooks/useUISignals";
import { isSignalsManagementOpenAction, openSignalsManagementForType } from "../../store/action-creators";

interface IProps {
    emptyButtonText?: string;
    fillButtonText?: string;
    preselectedSignalType?: SignalType;
    height?: IButtonProps["height"];
    iconSize?: string;
    onClick?: VoidFunction;
}

const SignalsManagementButtonContainer = ({
    emptyButtonText,
    fillButtonText,
    preselectedSignalType,
    height,
    iconSize,
    onClick,
}: IProps) => {
    const dispatch = useDispatch();

    const numberOfSignals = usePermanentSignalsAmountBySource();

    const handleClick = (): void => {
        onClick?.();

        if (preselectedSignalType) {
            dispatch(openSignalsManagementForType(preselectedSignalType));
            return;
        }

        dispatch(isSignalsManagementOpenAction(true));
    };

    return (
        <SignalsManagementButton
            height={height}
            iconSize={iconSize}
            isSignalsListEmpty={numberOfSignals === 0}
            onClick={handleClick}
            emptyListBtnText={emptyButtonText}
            fillListBtnText={fillButtonText}
        />
    );
};

export default SignalsManagementButtonContainer;
